<ng-container *ngIf="!hidden">
  <app-scrolling-top-banner
    [bannerText]="bannerText"
    [bgColor]="'#1A1A1A'"
    [onClick]="handleClick"
    [onClose]="handleClose"
  />
</ng-container>